import { constants } from "./constants";

const {
  SET_AREAS,
  SET_CHECKED_AREAS,
  RESET_CHECKED_AREAS,
  SET_TREES,
  RESET_TREES,
  SET_CHECKED_TREES,
  RESET_CHECKED_TREES,
  SET_INSTALLATIONS,
  RESET_INSTALLATIONS,
  SET_CHECKED_INSTALLATIONS,
  RESET_CHECKED_INSTALLATIONS,
  SET_VARIABLES,
  RESET_VARIABLES,
  SET_CHECKED_VARIABLES,
  RESET_CHECKED_VARIABLES,
  SET_RAIN_AREA,
  SET_HEALTH_TREE,
  SET_IRRIGATION_TREE,
} = constants;

const filterReducer = (state, { type, payload }) => {
  switch (type) {
    case SET_AREAS:
      return { ...state, areas: payload };

    case RESET_CHECKED_AREAS: {
      return { ...state, areasId: payload };
    }

    case SET_CHECKED_AREAS: {
      const areasId = state.areasId;
      const p = new Set(payload.flat());
      return { ...state, areasId: [...areasId, ...p].flat() };
    }

    case SET_TREES: {
      const trees = state.trees;
      const p = new Set(payload.flat());
      return { ...state, trees: [...trees, ...p].flat() };
    }
    case RESET_TREES: {
      // const finalTrees = new Set(payload);
      const p = new Set(payload.flat());
      return { ...state, trees: [...p].flat() };
    }

    case SET_CHECKED_TREES: {
      const treesId = state.treesId;
      const p = new Set(payload.flat());
      return { ...state, treesId: [...treesId, ...p].flat() };
    }
    case RESET_CHECKED_TREES: {
      const p = new Set(payload.flat());
      return { ...state, treesId: [...p].flat() };
    }

    case RESET_INSTALLATIONS: {
      const p = new Set(payload.flat());
      return { ...state, installations: [...p].flat() }; // Directly return a new state object with updated treesId.
    }
    case SET_INSTALLATIONS: {
      return { ...state, installations: payload }; // Directly return a new state object with updated treesId.
    }

    case SET_CHECKED_INSTALLATIONS: {
      const installationsId = state.installationsId;
      const newInstallationsId = new Set([...installationsId, ...payload]);

      return { ...state, installationsId: [...newInstallationsId].flat() }; // Directly return a new state object with updated treesId.
    }

    case RESET_CHECKED_INSTALLATIONS: {
      const p = new Set(payload.flat());
      return { ...state, installationsId: [...p].flat() }; // Directly return a new state object with updated treesId.
    }
    case RESET_VARIABLES: {
      const p = new Set(payload.flat());
      return { ...state, variables: [...p].flat() };
    }
    case SET_VARIABLES: {
      const variables = state.variables;
      const newVariables = new Set([...variables, ...payload]);
      return { ...state, variables: [...newVariables].flat() };
    }
    case SET_CHECKED_VARIABLES: {
      const variablesId = state.variablesId;
      const newVariablesId = new Set([...variablesId, ...payload]);
      return { ...state, variablesId: [...newVariablesId].flat() };
    }
    case RESET_CHECKED_VARIABLES: {
      const p = new Set(payload.flat());
      return { ...state, variablesId: [...p].flat() };
    }
    case SET_RAIN_AREA: {
      return { ...state, rainAreaId: payload };
    }
    case SET_HEALTH_TREE: {
      return { ...state, healthTreeId: payload };
    }
    case SET_IRRIGATION_TREE: {
      return { ...state, irrigationTreeId: payload };
    }
    default:
      return state;
  }
};

export default filterReducer;
